import LegalHeader from "@/components/LegalHeader";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <LegalHeader />
      <main className="pt-20 pb-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-primary mb-4">
                Privacy Policy
              </h1>
              <p className="text-muted-foreground">
                Ultimo aggiornamento: 16 marzo 2026
              </p>
            </div>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">1. Titolare del Trattamento</h2>
                <p>
                  <strong>DA ARMANDO S.R.L.</strong><br />
                  Sede legale: Via Aganoor Pompili, 25 — 06065 Passignano sul Trasimeno (PG)<br />
                  P.IVA / C.F. e n. iscr. Registro Imprese: 03963890540<br />
                  REA: PG-368050<br />
                  Capitale sociale: € 4.800,00 i.v.<br />
                  Amministratrice Unica: Mulla Xhirela<br />
                  PEC: daarmando@pec.it<br />
                  Tel: +39 075 388 0397
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">2. Finalità e Base Giuridica del Trattamento</h2>
                <p>I Suoi dati personali saranno trattati per le seguenti finalità:</p>
                <div className="overflow-x-auto mt-4">
                  <table className="min-w-full border border-border text-sm">
                    <thead>
                      <tr className="bg-muted">
                        <th className="border border-border px-4 py-2 text-left">Finalità</th>
                        <th className="border border-border px-4 py-2 text-left">Base giuridica</th>
                        <th className="border border-border px-4 py-2 text-left">Dati trattati</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-border px-4 py-2">Gestione delle prenotazioni e dei servizi richiesti</td>
                        <td className="border border-border px-4 py-2">Esecuzione di misure precontrattuali e contrattuali (art. 6(1)(b) GDPR)</td>
                        <td className="border border-border px-4 py-2">Nome, email, telefono, data, ora, n. persone, note</td>
                      </tr>
                      <tr>
                        <td className="border border-border px-4 py-2">Invio conferma prenotazione via email</td>
                        <td className="border border-border px-4 py-2">Esecuzione di misure precontrattuali (art. 6(1)(b) GDPR)</td>
                        <td className="border border-border px-4 py-2">Nome, email, dettagli prenotazione</td>
                      </tr>
                      <tr>
                        <td className="border border-border px-4 py-2">Notifica interna al ristorante delle nuove prenotazioni</td>
                        <td className="border border-border px-4 py-2">Legittimo interesse (art. 6(1)(f) GDPR)</td>
                        <td className="border border-border px-4 py-2">Nome, dettagli prenotazione</td>
                      </tr>
                      <tr>
                        <td className="border border-border px-4 py-2">Adempimenti di legge e contabili</td>
                        <td className="border border-border px-4 py-2">Obbligo di legge (art. 6(1)(c) GDPR)</td>
                        <td className="border border-border px-4 py-2">Dati necessari per gli adempimenti fiscali</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">3. Categorie di Dati Trattati</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Dati anagrafici:</strong> nome</li>
                  <li><strong>Dati di contatto:</strong> email, telefono</li>
                  <li><strong>Dati relativi alle prenotazioni:</strong> data, ora, numero persone, note</li>
                  <li><strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser e dispositivo (raccolti automaticamente dai server)</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">4. Destinatari e Responsabili del Trattamento</h2>
                <p>I Suoi dati personali possono essere comunicati ai seguenti soggetti terzi, che agiscono in qualità di responsabili del trattamento ai sensi dell'art. 28 GDPR:</p>
                <div className="overflow-x-auto mt-4">
                  <table className="min-w-full border border-border text-sm">
                    <thead>
                      <tr className="bg-muted">
                        <th className="border border-border px-4 py-2 text-left">Fornitore</th>
                        <th className="border border-border px-4 py-2 text-left">Servizio</th>
                        <th className="border border-border px-4 py-2 text-left">Paese</th>
                        <th className="border border-border px-4 py-2 text-left">Garanzie trasferimento</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-border px-4 py-2"><strong>Supabase Inc.</strong></td>
                        <td className="border border-border px-4 py-2">Database e gestione prenotazioni</td>
                        <td className="border border-border px-4 py-2">USA (server AWS)</td>
                        <td className="border border-border px-4 py-2">Standard Contractual Clauses (SCC)</td>
                      </tr>
                      <tr>
                        <td className="border border-border px-4 py-2"><strong>Resend Inc.</strong></td>
                        <td className="border border-border px-4 py-2">Invio email transazionali (conferma prenotazione)</td>
                        <td className="border border-border px-4 py-2">USA</td>
                        <td className="border border-border px-4 py-2">EU-US Data Privacy Framework (DPF)</td>
                      </tr>
                      <tr>
                        <td className="border border-border px-4 py-2"><strong>Telegram FZ-LLC</strong></td>
                        <td className="border border-border px-4 py-2">Notifiche interne al personale del ristorante</td>
                        <td className="border border-border px-4 py-2">UAE / UK</td>
                        <td className="border border-border px-4 py-2">Legittimo interesse; dati minimizzati alle informazioni della prenotazione</td>
                      </tr>
                      <tr>
                        <td className="border border-border px-4 py-2"><strong>Google LLC</strong></td>
                        <td className="border border-border px-4 py-2">Google Maps (solo se l'utente acconsente al caricamento della mappa)</td>
                        <td className="border border-border px-4 py-2">USA</td>
                        <td className="border border-border px-4 py-2">EU-US Data Privacy Framework (DPF)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">5. Trasferimenti di Dati Extra-UE</h2>
                <p>
                  Alcuni dei fornitori sopra indicati hanno sede negli Stati Uniti. I trasferimenti sono effettuati sulla base delle seguenti garanzie:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>EU-US Data Privacy Framework (DPF):</strong> per i fornitori certificati (Resend, Google), sulla base della decisione di adeguatezza della Commissione Europea del 10 luglio 2023.</li>
                  <li><strong>Standard Contractual Clauses (SCC):</strong> per Supabase, che non è certificato DPF, il trasferimento avviene sulla base delle clausole contrattuali tipo approvate dalla Commissione Europea.</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">6. Conservazione dei Dati</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Dati di prenotazione:</strong> 10 anni (obblighi contabili e fiscali)</li>
                  <li><strong>Dati di navigazione:</strong> 12 mesi</li>
                  <li><strong>Preferenze cookie:</strong> fino alla cancellazione manuale da parte dell'utente</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">7. Diritti dell'Interessato</h2>
                <p>Ai sensi degli artt. 15-22 del GDPR, Lei ha il diritto di:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Accedere ai propri dati personali (art. 15)</li>
                  <li>Rettificare i dati inesatti (art. 16)</li>
                  <li>Cancellare i propri dati — diritto all'oblio (art. 17)</li>
                  <li>Limitare il trattamento (art. 18)</li>
                  <li>Portabilità dei dati (art. 20)</li>
                  <li>Opporsi al trattamento (art. 21)</li>
                  <li>Revocare il consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento basato sul consenso prestato prima della revoca</li>
                  <li>Proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali</li>
                </ul>
                <p className="mt-4">
                  Per esercitare i Suoi diritti, può scrivere a: <strong>Mullaxhirela@gmail.com</strong> o telefonare al <strong>+39 075 388 0397</strong>
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">8. Cookie</h2>
                <p>
                  Il nostro sito utilizza cookie tecnici necessari per il funzionamento del sito. Per la mappa interattiva, i cookie di Google Maps vengono caricati solo dopo il consenso esplicito dell'utente. Per maggiori dettagli, consulti la nostra{" "}
                  <a href="/cookie-policy" className="text-gold underline">Cookie Policy</a>.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">9. Sicurezza</h2>
                <p>Adottiamo misure di sicurezza tecniche e organizzative appropriate per proteggere i Suoi dati personali da accessi non autorizzati, divulgazione, alterazione o distruzione, tra cui crittografia dei dati in transito (HTTPS/TLS) e controllo degli accessi.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">10. Contatti e Reclami</h2>
                <p>Per esercitare i Suoi diritti o per qualsiasi domanda sulla privacy, può contattarci:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Email: Mullaxhirela@gmail.com</li>
                  <li>Telefono: +39 075 388 0397</li>
                  <li>Posta: Via Aganoor Pompili, 25, 06065 Passignano sul Trasimeno (PG)</li>
                </ul>
                <p className="mt-4">
                  Per proporre reclamo, può rivolgersi al <strong>Garante per la Protezione dei Dati Personali</strong>:<br />
                  Piazza Venezia 11, 00187 Roma<br />
                  <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-gold underline">www.garanteprivacy.it</a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
